/**
 * Owners API — Settings → Owners + project picker
 */
import { apiFetch } from './client'

export interface Owner {
  id: number
  user_id: number
  name: string
  contact_names: string | null
  email: string | null
  email_is_placeholder?: boolean
  email_pending?: boolean
  phone: string | null
  address: string | null
  default_terms: string | null
  pays_by: string | null
  created_at?: string
  project_count?: number
}

export interface UnlinkedOwnerString {
  owner_name: string
  project_count: number
}

type Envelope<T> = { data: T; error: string | null; message: string }

export async function listOwners(): Promise<Owner[]> {
  const res = await apiFetch<Envelope<Owner[]>>('GET', '/api/owners')
  return res.data || []
}

export async function listUnlinkedOwnerStrings(): Promise<UnlinkedOwnerString[]> {
  const res = await apiFetch<Envelope<UnlinkedOwnerString[]>>('GET', '/api/owners/unlinked-strings')
  return res.data || []
}

export async function createOwner(body: Partial<Owner>): Promise<Owner> {
  const res = await apiFetch<Envelope<Owner>>('POST', '/api/owners', body)
  return res.data
}

export async function updateOwner(id: number, body: Partial<Owner>): Promise<Owner> {
  const res = await apiFetch<Envelope<Owner>>('PUT', `/api/owners/${id}`, body)
  return res.data
}

export async function createOwnerFromString(body: {
  owner_name: string
  name?: string
  email?: string | null
}): Promise<{ owner: Owner; linked: unknown[] }> {
  const res = await apiFetch<Envelope<{ owner: Owner; linked: unknown[] }>>(
    'POST',
    '/api/owners/from-string',
    body,
  )
  return res.data
}

export async function linkProjectsToOwner(
  ownerId: number,
  projectIds: number[],
  normalizeDisplay = true,
): Promise<unknown[]> {
  const res = await apiFetch<Envelope<unknown[]>>(
    'POST',
    `/api/owners/${ownerId}/link-projects`,
    { project_ids: projectIds, normalize_display: normalizeDisplay },
  )
  return res.data
}
